import { render, staticRenderFns } from "./ClientNotes.vue?vue&type=template&id=11cf759c&"
import script from "./ClientNotes.vue?vue&type=script&lang=js&"
export * from "./ClientNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports